<template lang="pug">
//- 文档列表
van-pull-refresh.folderList(v-model="refreshing" v-loading="loading" @refresh="onRefresh")
  .folderItem(v-for="item in myDocList" :key="item.folderId" :class="{ 'folderActive': item.isSelected }" @click="nextDetails(item)")
    van-image.leftIcon(fit="contain" :src="logoSrc(item)" @click.stop="select(item)")
    .folder_name
      .file {{ item.folderName }}
      .date {{ item.checkInDate || item.operDate }}
  .empty(v-if="!myDocList.length") 暂无数据
</template>

<script>
import { mapState } from "vuex";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";

export default {
  props: ["keyword", "prjId"],
  components: {},
  data() {
    return {
      myDocList: [], // 我的文档列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    keyword(value) {
      if (value) this.getMyDocList();
    }
  },
  mounted() {
    this.getMyDocList();
  },
  methods: {
    // logo图片地址
    logoSrc(item) {
      return tableRowIcon(item);
    },
    // 获得我的文档列表
    async getMyDocList() {
      this.loading = true;
      try {
        const prjId = this.prjId;
        const folderId = 0; // 根文件夹
        const params = { prjId, folderId, keyWord: this.keyword };
        const res = await docService.querySearchFolder(params);
        this.myDocList = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    // 刷新列表
    toRefresh() {
      this.getMyDocList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getMyDocList();
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(async function (item) {
      if (item.isFolder === 1) {
        this.intoFolder(item);
      } else {
        this.select(item);
      }
    }),
    // 进入选中的文件夹
    async intoFolder(folder) {
      this.loading = true;
      try {
        let { folderId } = folder || {};
        const { data } = await docService.navbar(1, folderId);
        let rootNav = { folderId: 0, folderName: "文档" };
        let navList = [rootNav, ...data];
        this.$emit("intoFolder", navList); // 文件夹路径
      } finally {
        this.loading = false;
      }
    },

    // 选中
    select(item) {
      if (item.isSelected) this.$set(item, "isSelected", false);
      else this.$set(item, "isSelected", true);
    },
    // 获得选中列表
    getCheckedList() {
      let selectedList = this.myDocList.filter((e) => e.isSelected);
      return selectedList || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.folderList {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999;
    font-size: 16px;
  }
}

.folderItem {
  width: 100%;
  height: 70px;
  padding: 0 3vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .leftIcon {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .folder_name {
    width: calc(100% - 75px);
    height: 50px;
    overflow-x: overlay !important;
    overflow-x: auto;

    .file {
      font-size: 16px;
      line-height: 20px;
      color: #323232;
      white-space: nowrap;
      margin-top: 6px;
    }
    .date {
      font-size: 13px;
      line-height: 16px;
      color: #999999;
      white-space: nowrap;
    }
  }

  .rightIcon {
    padding: 6px;
    font-size: 18px;
  }
}
.folderActive {
  background-color: #7fc65c;
  .file,
  .date {
    color: #fff !important;
  }
}
</style>
